import { Injectable } from '@angular/core';
import type {
  CardReferenceModel,
  LastTransactionModel,
  MemberProfileModel,
} from '../api/auth.models';

export type LoginAction = 'activate' | 'confirm' | 'register';

export interface PendingAuthSession {
  action: LoginAction;
  cardNumber: string;
  activationCardNumber?: string;
  isBiometric: boolean;
  member?: MemberProfileModel;
  virtualCard?: CardReferenceModel;
  physicalCard?: CardReferenceModel | null;
  mobileNumber?: string;
  lastTransaction?: LastTransactionModel | null;
}

@Injectable({ providedIn: 'root' })
export class AuthSessionService {
  private readonly storageKey = 'auth.pendingSession';
  private pendingSession: PendingAuthSession | null = this.loadFromStorage();

  setPendingSession(session: PendingAuthSession): void {
    this.pendingSession = session;
    sessionStorage.setItem(this.storageKey, JSON.stringify(session));
  }

  getPendingSession(): PendingAuthSession | null {
    return this.pendingSession;
  }

  clearPendingSession(): void {
    this.pendingSession = null;
    sessionStorage.removeItem(this.storageKey);
  }

  private loadFromStorage(): PendingAuthSession | null {
    const raw = sessionStorage.getItem(this.storageKey);
    if (!raw) {
      return null;
    }

    try {
      const parsed = JSON.parse(raw) as PendingAuthSession;
      if (!parsed.cardNumber || !parsed.action) {
        return null;
      }
      return parsed;
    } catch {
      return null;
    }
  }
}
